export const FIGMA_TO_STORYCARDS_TITLE = 'Figma to Storycards: Build Interactive Products with AI';

export const FIGMA_TO_STORYCARDS_DESCRIPTION =
  'Connect Figma in Storycards AI Chat. Storycards reads designs and element comments, builds interactive behavior, and opens editable layers in Studio.';

export const figmaToStorycardsFaqs = [
  {
    question: 'Does Storycards require a Figma plugin?',
    answer:
      'No. The workflow starts in Storycards AI Chat, where you connect the Figma file you want to use. There is no separate plugin step for the design team.',
  },
  {
    question: 'How does Storycards use comments attached to Figma elements?',
    answer:
      'Storycards reads each comment in the context of the element it is attached to. Instructions about motion, timing, sliders, states and other behavior can guide the generated interaction.',
  },
  {
    question: 'What makes this different from a standard Figma import?',
    answer:
      'Storycards brings the visual structure and the intent captured in comments into the same build. The result opens in Studio as editable layers rather than a flattened file.',
  },
  {
    question: 'Can I edit the result in Storycards Studio?',
    answer: 'Yes. Refine layout, styles, responsive behavior, motion and product logic in Studio before publishing.',
  },
  {
    question: 'Does Storycards publish the result automatically?',
    answer:
      'No. The generated product opens in Studio for review and refinement. Your team decides when it is ready to publish.',
  },
];

export const FIGMA_TO_STORYCARDS_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': ['WebPage', 'FAQPage'],
      '@id': 'https://storycards.com/figma-to-storycards#webpage',
      url: 'https://storycards.com/figma-to-storycards',
      name: FIGMA_TO_STORYCARDS_TITLE,
      description: FIGMA_TO_STORYCARDS_DESCRIPTION,
      inLanguage: 'en',
      dateModified: '2026-10-03',
      isPartOf: { '@id': 'https://storycards.com/#website' },
      breadcrumb: { '@id': 'https://storycards.com/figma-to-storycards#breadcrumb' },
      about: {
        '@type': 'SoftwareApplication',
        name: 'Storycards',
        applicationCategory: 'DesignApplication',
        operatingSystem: 'Web',
      },
      mainEntity: figmaToStorycardsFaqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    },
    {
      '@type': 'BreadcrumbList',
      '@id': 'https://storycards.com/figma-to-storycards#breadcrumb',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://storycards.com/' },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Figma to Storycards',
          item: 'https://storycards.com/figma-to-storycards',
        },
      ],
    },
  ],
};
